import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A55AD931-CE89-49C0-9F1C-F699C422843C
 * name currency-ils
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-ils.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const CurrencyIlsIcon = createSvgIcon(<><path d="M22,16A5,5 0 0,1 17,21H8V9H10V19H17A3,3 0 0,0 20,16V3H22V16M16,8V15H14V8A3,3 0 0,0 11,5H4V21H2V3H11A5,5 0 0,1 16,8Z" /></>, 'CurrencyIlsIcon');
export default CurrencyIlsIcon